'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();

import { Button } from '@qogita/ui/v2/button'
import { PopupButton } from '@typeform/embed-react'
import { useBrowserTracker } from 'src/core/tracking/browser'

/**
 * ### This is the unique id from typeform for the new seller form.
 *  This specific id is from https://qogita.typeform.com/newsellerform. Ask product for this id.
 *
 **/
const NEW_SELLER_FORM_TYPEFORM_ID = 'pWDnXPe4'

export function SignUpButton() {
  const browserTracker = useBrowserTracker()

  return (
    <PopupButton
      type="button"
      onSubmit={(event) => {
        browserTracker.track('Sign Up Submitted', {
          typeformId: NEW_SELLER_FORM_TYPEFORM_ID,
          typeformResponseId: event.responseId,
        })
      }}
      // @ts-expect-error the following is a valid element
      as={(buttonProps) => (
        <p>
          New to Qogita?{' '}
          <Button
            {...buttonProps}
            variant="text"
            rumActionName="Get started"
            rumData={{
              typeformID: NEW_SELLER_FORM_TYPEFORM_ID,
            }}
          >
            Get started
          </Button>
        </p>
      )}
      id={NEW_SELLER_FORM_TYPEFORM_ID}
    />
  )
}
